import { render } from "./ChangePasswordUserDialog.vue?vue&type=template&id=5a8ff574&lang=pug"
import script from "./ChangePasswordUserDialog.vue?vue&type=script&lang=js"
export * from "./ChangePasswordUserDialog.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__